import RenderTable from "../../Render/RenderTable";
import { Box } from "@mui/material";
import { isEmpty, isNull, isUndefined } from "lodash";
import DatePicker from "../../../../../_utils/DatePicker";
import React, { useEffect, useState } from "react";
import { getAPWithMostActivation } from "../../../../../../features/user/analytics/analyticsSlice";
import { useSelector, useDispatch } from "react-redux";
import { lastTEDays } from "../../../../../_utils/DateUtils";

const apWithMostActivationHeaders = [
  { key: "rank", label: "Rank" },
  { key: "name", label: "Access Point Name" },
  { key: "type", label: "Type" },
  { key: "growth", label: "Growth" },
  { key: "activations", label: "Activations" },
];

const AccessPointsWithMostActivation = () => {
  const dispatch = useDispatch();
  const apWithMostActivation = useSelector(
    (state) => state.analytics.apWithMostActivation
  );

  const [dateObj, setDateObj] = useState(lastTEDays);
  useEffect(() => {
    dispatch(getAPWithMostActivation({ limit: 5, ...dateObj }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="analytics">
      <div className="analyticshome__anCard">
        <div className="row analyticshome__anCard--contentRow">
          <div className="col-9">
            <div className="analyticshome__anCard--contentRow--header">
              Access Point List
            </div>
          </div>
          <div className="col-3" style={{ paddingRight: "2.5rem" }}>
            <Box component="span" className="analyticshome__anCard--filterBox">
              <span style={{ color: "#858993" }}>Date:</span>
              <DatePicker
                cb={(dateObj) => {
                  setDateObj(dateObj);
                  dispatch(getAPWithMostActivation({ limit: 5, ...dateObj }));
                }}
              />
            </Box>
            {/* } */}
          </div>
        </div>
        <hr />

        {isEmpty(apWithMostActivation?.data) ||
        isNull(apWithMostActivation?.data) ||
        isUndefined(apWithMostActivation?.data) ? (
          <h5 className="text-center analyticshome__emptyStateText pt-3">
            {" "}
            No Data available{" "}
          </h5>
        ) : (
          <RenderTable
            thheaderData={apWithMostActivationHeaders}
            rowsData={apWithMostActivation?.data}
          />
        )}
      </div>
    </div>
  );
};

export default AccessPointsWithMostActivation;
